import React, { useState } from "react";
import "./EnrollmentForm.css";
import { useCallback } from "react";
import { getEnrollmentForm } from "../../../actions/creation/getEnrollmentForm";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import capitalize from "../../../helpers/lodashUtils/capitalize";
import { QuestionType } from "../../../helpers/constants/constant.js";
import { ImageListView } from "../components/ImageListView";
import { black100, white } from "../../../theme/colors";
import PhotoViewer from "../outlets/imageRetailerEdit.js";
import TncViewer from "../components/TNCViewer.js";
import { GENERATE_CONSENT_OTP, GENERATE_ENROLLMENT_OTP, GET_SUBMIT_ENROLLMENT_FORM } from "../../../helpers/constants/apiUrl.js";
import { triggerSimpleAjax } from "../../../helpers/httpHelper.js";

export default function EnrollmentForm() {
  const { search, pathname } = useLocation();

  const urlNew = search;
  const matchNew = urlNew.match(/\?([^/]+)/);
  const queryPartNew = urlNew.split("?")[1];
  if (!queryPartNew) throw new Error("Invalid URL: missing '?'");

  const partsNew = queryPartNew.split("/");
  const firstPart = matchNew ? matchNew[1] : null;
  const secondPart = partsNew[1];
  const thirdPart = partsNew[2];

  const decodedMobileNumber = secondPart ? decodeBase64(secondPart) : null;

  function decodeBase64(str) {
    try {
      return decodeURIComponent(escape(window.atob(str)));
    } catch (error) {
      console.log("Decode Error", error);
      return "";
    }
  }


  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [actionType, setActionType] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isActionLocked, setIsActionLocked] = useState(false);

  const [enrollmentData, setEnrollmentData] = useState(null);

  const [showImage, setShowImage] = useState(false);
  const [questionImageList, setQuestionImageList] = useState([]);
  const [questionImageIndex, setQuestionImageIndex] = useState(0);
  const [isEsignatureImage, setIsEsignatureImage] = useState(false);

  const [showRejectReason, setShowRejectReason] = useState(false);
  const [selectedRejectReason, setSelectedRejectReason] = useState("");
  const [otherRejectReason, setOtherRejectReason] = useState("");
  const [otpTimer, setOtpTimer] = useState(60);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [apiError, setApiError] = useState(false);

  const fetchConsentForm = useCallback(async () => {
    try {
      const response = await getEnrollmentForm(`${firstPart}/`);

      if (response && response.code == 200 && response.success == true) {
        setEnrollmentData({
          ...response.result,
          outlet_enrollment: response.outlet_enrollment || response.result?.outlet_enrollment
        });
        setApiError(false);
      } else {
        setApiError(true);
      }

    } catch (error) {
      console.error("Error fetching retailer requests:", error);
      setApiError(true);
    }
  }, [firstPart]);

  useEffect(() => {
    fetchConsentForm();
  }, [fetchConsentForm]);

  useEffect(() => {
    let interval = null;

    if (showOtp) {
      interval = setInterval(() => {
        setOtpTimer((prev) => {

          if (prev <= 1) {
            clearInterval(interval);
            setCanResendOtp(true);
            return 0;
          }

          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [showOtp]);
  // Function to generate OTP for consent code verification
  const generateEnrollmentOtp = () => {

    const payload = {
      phone_number: decodedMobileNumber,
      type_of_request: "enrollment_verification",
      outlet_slug: firstPart,
    };

    triggerSimpleAjax(
      GENERATE_ENROLLMENT_OTP,
      "POST",
      payload,
      (response) => {

        console.log("OTP Generated", response);

        // clear old otp
        setOtp("");
        setOtpError("");

        // restart timer
        setCanResendOtp(false);
        setOtpTimer(60);

        // reopen popup if needed
        setShowOtp(true);
      },
      (error) => {
        console.log("OTP Error", error);
      }
    );
  };

  const handleEnrollmentSubmit = (status) => {

    const payload = {
      outlet_slug: firstPart,
      otp: otp,
      phone_number: decodedMobileNumber,
      enrollment_status: status,
    };

    // ACCEPT
    if (status === "accepted") {
      payload.result = enrollmentData;
    }

    // REJECT
    if (status === "rejected") {
      payload.rejection_reason =
        selectedRejectReason === "other_reason"
          ? otherRejectReason
          : selectedRejectReason;
    }

    triggerSimpleAjax(
      GET_SUBMIT_ENROLLMENT_FORM,
      "POST",
      payload,
      (response) => {
        console.log("Submit Success", response);

        setShowOtp(false);
        setShowRejectReason(false);

        // reset reject reason state
        setSelectedRejectReason("");
        setOtherRejectReason("");

        // reset otp state
        setOtp("");
        setOtpError("");

        setShowSuccess(true);
        setIsActionLocked(false);

        // Optimistically update status to avoid delay
        setEnrollmentData((prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            outlet_enrollment: {
              ...prev.outlet_enrollment,
              enrollment_status: status,
            },
          };
        });

        // Refetch enrollment form details to sync with server
        fetchConsentForm();
      },
      (error) => {
        console.log("Submit Error", error);

        if (error?.responseJSON?.message) {
          setOtpError(error.responseJSON.message);
        } else {
          setOtpError("Invalid OTP.");
        }

        setShowOtp(true);
        setShowSuccess(false);
        setIsActionLocked(false);
      }
    );
  };

  const handleImageClick = () => {
    setShowImage(!showImage);
  };

  const handleCloseImage = () => {
    setShowImage(false);
  };

  const resetModals = () => {
    setShowConfirm(false);
    setShowOtp(false);
    setShowSuccess(false);
    setOtp("");
    setOtpError("");
  };

  const onAccept = () => {
    if (isActionLocked) return;
    setIsActionLocked(true);
    resetModals();
    setActionType("accepted");
    setShowConfirm(true);
  };

  const onReject = () => {
    if (isActionLocked) return;
    setIsActionLocked(true);
    resetModals();
    setActionType("rejected");
    setShowConfirm(true);
  };

  const handleCancelConfirm = () => {
    setShowConfirm(false);
    setIsActionLocked(false);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    setShowOtp(true);
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();

    if (!otp || otp.length !== 6) {
      setOtpError("Enter valid 6-digit OTP");
      return;
    }

    setOtpError("");
    setShowOtp(false);
    setShowSuccess(true);

    handleEnrollmentSubmit(actionType);
  };

  const renderStatusMessage = () => {
    const status = enrollmentData?.outlet_enrollment?.enrollment_status?.toLowerCase();

    if (status === "accepted") {
      return (
        <div className="enrollment-status-message accepted">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px' }}>
            <circle cx="12" cy="12" r="10" fill="#e8f8f0" stroke="#2ecc71" strokeWidth="2" />
            <path d="M8 12L11 15L16 9" stroke="#2ecc71" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Enrollment Accepted
        </div>
      );
    }

    if (status === "rejected") {
      return (
        <div className="enrollment-status-message rejected">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px' }}>
            <circle cx="12" cy="12" r="10" fill="#fff1f0" stroke="#ff4d4f" strokeWidth="2" />
            <path d="M15 9L9 15M9 9L15 15" stroke="#ff4d4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Enrollment Rejected
        </div>
      );
    }

    if (status === "refused") {
      return (
        <div className="enrollment-status-message refused">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px' }}>
            <circle cx="12" cy="12" r="10" fill="#fef9e7" stroke="#f39c12" strokeWidth="2" />
            <path d="M12 9V13M12 16H12.01" stroke="#f39c12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Enrollment Refused
        </div>
      );
    }

    return (
      <div className="enrollment-status-message default-status">
        Enrollment Status: {capitalize(status || "")}
      </div>
    );
  };

  if (apiError) {
    return (
      <div className="enrollment-background" style={{ alignItems: "center" }}>
        <div className="enrollment-error-container">
          <div className="enrollment-error-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#FEE2E2" stroke="#EF4444" strokeWidth="1.5" />
              <path d="M12 8V13" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
              <circle cx="12" cy="16" r="1" fill="#EF4444" />
            </svg>
          </div>
          <h2 className="enrollment-error-title">Enrollment has been closed</h2>
          <p className="enrollment-error-message">
            You can no longer respond to this enrollment request.
          </p>

        </div>
      </div>
    );
  }

  return (
    <div className="enrollment-background">
      {/* REJECT REASON POPUP */}
      {showRejectReason && (
        <div
          className="popup-overlay"
          onClick={() => setShowRejectReason(false)}
        >
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-message">
              Select Rejection Reason
            </div>

            <select
              value={selectedRejectReason}
              onChange={(e) => setSelectedRejectReason(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "15px",
                borderRadius: "8px",
                border: "1px solid #d9d9d9",
                maxHeight: "200px"

              }}
            >
              <option value="">Select Reason</option>

              {enrollmentData?.rejection_reasons?.map((item) => (
                <option key={item.key} value={item.key}>
                  {item.label}
                </option>
              ))}
            </select>

            {selectedRejectReason === "other_reason" && (
              <textarea
                placeholder="Enter reason"
                value={otherRejectReason}
                onChange={(e) => setOtherRejectReason(e.target.value)}
                style={{
                  width: "100%",
                  marginTop: "12px",
                  minHeight: "140px",
                  padding: "10px",
                  borderRadius: "8px",
                  resize: "none",
                  outline: "none",
                  border: "1px solid #d9d9d9"
                }}
              />
            )}

            <div
              className="popup-actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                marginTop: "20px"
              }}
            >
              <button
                className="btn btn-cancel"
                onClick={() => {
                  setShowRejectReason(false);
                  setSelectedRejectReason("");
                  setOtherRejectReason("");
                }}
                style={{
                  minWidth: "120px"
                }}
              >
                Cancel
              </button>

              <button
                className="btn btn-confirm"
                onClick={() => {

                  if (!selectedRejectReason) {
                    alert("Please select rejection reason");
                    return;
                  }

                  if (
                    selectedRejectReason === "other_reason" &&
                    !otherRejectReason.trim()
                  ) {
                    alert("Please enter rejection reason");
                    return;
                  }

                  generateEnrollmentOtp();

                  setShowRejectReason(false);
                  setShowOtp(true);
                }}
                style={{
                  background: "#ff4d4f",
                  color: "#fff",
                  minWidth: "120px"
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
      {/* OTP POPUP */}
      {/* OTP POPUP */}
      {showOtp && (
        <div className="popup-overlay">
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>

            <div className="popup-message">
              Enter OTP to confirm {actionType}
            </div>

            <form onSubmit={handleOtpSubmit}>

              <input
                type="text"
                maxLength={6}
                value={otp}
                onChange={(e) =>
                  setOtp(e.target.value.replace(/[^0-9]/g, ""))
                }
                placeholder="------"
                inputMode="numeric"
                autoFocus
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  marginTop: "15px",
                  border: "1px solid #d9d9d9",
                  fontSize: "16px",
                  textAlign: "center",
                  letterSpacing: "6px"
                }}
              />

              {otpError && (
                <div
                  className="popup-error"
                  style={{
                    marginTop: "10px",
                    color: "#ff4d4f",
                    fontSize: "14px",
                    textAlign: "center"
                  }}
                >
                  {otpError}
                </div>
              )}

              {/* BUTTONS */}
              <div
                className="popup-actions"
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "20px"
                }}
              >
                <button
                  type="button"
                  className="btn btn-cancel"
                  style={{ flex: 1 }}
                  onClick={() => {

                    setShowOtp(false);
                    setSelectedRejectReason("");
                    setOtherRejectReason("");


                    // clear otp
                    setOtp("");
                    setOtpError("");

                    // reset timer
                    setOtpTimer(60);
                    setCanResendOtp(false);

                    setIsActionLocked(false);
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-confirm"
                  style={{ flex: 1 }}
                >
                  Submit OTP
                </button>
              </div>

              {/* RESEND */}
              <div
                style={{
                  marginTop: "18px",
                  textAlign: "center"
                }}
              >
                {!canResendOtp ? (
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666"
                    }}
                  >
                    Resend OTP in 00:
                    {otpTimer < 10 ? `0${otpTimer}` : otpTimer}
                  </span>
                ) : (
                  <button
                    type="button"
                    onClick={() => {

                      generateEnrollmentOtp();

                      // clear old otp
                      setOtp("");
                      setOtpError("");
                    }}
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "#1890ff",
                      cursor: "pointer",
                      fontWeight: "600",
                      fontSize: "14px"
                    }}
                  >
                    Resend OTP
                  </button>
                )}
              </div>

            </form>
          </div>
        </div>
      )}

      {/* CONFIRM POPUP */}
      {showConfirm && (
        <div className="popup-overlay" onClick={handleCancelConfirm}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-message">
              Are you sure you want to {actionType} this form?
            </div>

            <div className="popup-actions">
              <button
                className="btn btn-cancel"
                onClick={() => {
                  setShowRejectReason(false);
                  setSelectedRejectReason("");
                  setOtherRejectReason("");
                }}
              >
                Cancel
              </button>

              <button
                className="btn btn-confirm"
                onClick={handleConfirm}
                style={{
                  background:
                    actionType === "accepted" ? "#2ecc71" : "#ff4d4f",
                  color: "#fff"
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SUCCESS POPUP */}
      {showSuccess && (
        <div className="popup-overlay" onClick={() => setShowSuccess(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div style={{ textAlign: "center" }}>
              {actionType === "accepted" ? (
                <>
                  <div className="success-tick-circle">✔</div>
                  <div className="popup-message" style={{ color: "#2ecc71" }}>
                    Form Accepted Successfully
                  </div>
                </>
              ) : (
                <>
                  <div className="rejected-cross-circle">✖</div>
                  <div className="popup-message" style={{ color: "#ff4d4f" }}>
                    Form Rejected
                  </div>
                </>
              )}

              <button
                className="btn btn-confirm"
                onClick={() => setShowSuccess(false)}
                style={{ marginTop: 15 }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DOCUMENT */}
      <div className="enrollment-document">

        {/* HEADER */}
        {/* <div className="enrollment-header">
          <div>
            <div className="brand-name">{enrollmentData?.sub_project_details?.enrollment_header}</div>
            <div className="form-title">{enrollmentData?.sub_project_details?.enrollment_sub_header}</div>
          </div>

        </div> */}

        <div className="enrollment-header">
          <div>
            <div className="brand-name">
              {enrollmentData?.sub_project_details?.enrollment_header}
            </div>

            <div className="form-title">
              {enrollmentData?.sub_project_details?.enrollment_sub_header}
            </div>
          </div>

          <img
            src={enrollmentData?.sub_project_details?.enrollment_logo_url}
            alt="logo"
            className="header-logo"
          />
        </div>

        {/* CONTENT */}
        <div className="enrollment-content">


          {enrollmentData?.data?.map((section, sIndex) => (
            <div className="enrollment-section" key={sIndex}>
              <div className="enrollment-section-header">
                <h2>{`Group ${(sIndex + 1)} : ${section.name}`}</h2>
              </div>

              {section.related_questions.map((row, rIndex) => (
                <React.Fragment key={rIndex}>

                  <div className="enrollment-row">
                    <div className="enrollment-label">{capitalize(row.name)}</div>

                    {rIndex < section.related_questions.length - 1 && <div className="pdf-line"></div>}

                    {row.prefill_answer != null ? (
                      <>
                        {(row.question_type == QuestionType.multiple_image || row.question_type == QuestionType.single_image
                          || row.question_type == QuestionType.invoice_image || row.question_type == QuestionType.image_upload|| row.question_type == QuestionType.e_signature)
                          ? (<>
                            <ImageListView
                              imageUrls={row?.prefill_answer?.images?.map(item => ({
                                id: item.id,
                                image_url: item.image
                              }))}
                              boxWidth={"500px"}
                              boxPadding="0px 0px"
                              background={row.question_type === QuestionType.e_signature ? white : black100}
                              // isQCEditable={isQcEditRequired}
                              fieldName={row.question_name}
                              imageUploadCallback={(uploadedImage) => {
                                // onUpdateUploadedImage({ e: uploadedImage, questionIndex, type: question_type, isAddNewImage: true });
                              }}
                              uploadedImageRemoveCallback={(removeImageId) => {
                                // onUpdateUploadedImage({ e: removeImageId, questionIndex, type: question_type, isAddNewImage: false });
                              }}
                              onViewAll={(imageList, index) => {
                                setQuestionImageIndex(index)
                                setQuestionImageList(imageList)
                                // setIsEsignatureImage(question_type === QuestionType.e_signature)
                                setTimeout(() => {
                                  handleImageClick()
                                }, 100);

                              }}
                            // warnMessage={
                            //   { text: errorMessageField, align: "right", onlyTextError: true }
                            // }
                            />
                          </>) : (
                            <div className="enrollment-value">
                              {capitalize(row?.prefill_answer?.details?.[0]?.input || "-")}
                            </div>
                          )}

                      </>
                    ) : (
                      <div className="enrollment-value">
                        {"-"}
                      </div>
                    )}

                    {/* {row.type === "currency" && (
                        <div className="enrollment-value">
                          Rs. <span className="pdf-line inline"></span>
                        </div>
                      )} */}

                    {/* {row.type === "range" && (
                      <div className="enrollment-value-row">
                        {row.fields.map((f, i) => (
                          <div className="enrollment-sub-field" key={i}>
                            <span>{f}:</span>
                            <div className="pdf-line small"></div>
                          </div>
                        ))}
                      </div>
                    )}

                    {row.type === "box" && <div className="pdf-box"></div>} */}
                  </div>

                  {/* {row.type === "text" && (
                    <div className="enrollment-terms">{row.value}</div>
                  )}

                  {row.type === "declaration" && (
                    <div className="declaration-box">{row.value}</div>
                  )}

                  {row.type === "signature" && (
                    <div className="signature-grid">
                      <div className="signature-item">
                        <span className="signature-label">
                          Retailer Signature
                        </span>

                        <div className="signature-fields">
                          {row.fields.map((field, i) => (
                            <div className="sig-field" key={i}>
                              <span>{field}</span>
                              <div className="pdf-line"></div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )} */}

                </React.Fragment>
              ))}
            </div>
          ))}

          {enrollmentData?.sub_project_details?.tnc && (
            <>
              <div className="enrollment-section-header">
                <h2>{`Terms and Conditions`}</h2>
              </div>

              <TncViewer tnc={enrollmentData?.sub_project_details?.tnc} />
            </>
          )}

          <div className="enrollment-footer">
            Governing Law: This Terms of Trade are governed by the laws of India and the Parties agree to submit to the exclusive jurisdiction of the courts of Mumbai.
          </div>

        </div>
        {
          showImage && (
            <div
              style={{
                marginTop: "10px",
                flex: "1 0 100%",
                backgroundColor: "#fff",
                padding: "10px"
              }}
            >
              {isEsignatureImage && (
                <style>
                  {`
                  .viewer-canvas img {
                    background-color: white !important;
                  }
                `}
                </style>
              )}
              {questionImageList.length > 0 ? (
                <PhotoViewer
                  images={questionImageList}
                  onClose={handleCloseImage}
                  indexImage={questionImageIndex}
                />
              ) : (
                <p>No image found</p>
              )}
            </div>
          )
        }

      </div>
      <div className="sticky-footer">
        <div className="footer-inner">
          {enrollmentData && (
            (enrollmentData?.outlet_enrollment?.enrollment_status?.toLowerCase() === "pending" || !enrollmentData?.outlet_enrollment?.enrollment_status) ? (
              <>
                <button
                  className="btn btn-accept"
                  onClick={() => {
                    generateEnrollmentOtp();
                    setActionType("accepted");
                    setShowOtp(true);
                  }}
                  disabled={isActionLocked}
                >
                  Accept
                </button>

                <button
                  className="btn btn-reject"
                  onClick={() => {
                    setActionType("rejected");
                    setShowRejectReason(true);
                  }}
                  disabled={isActionLocked}
                >
                  Reject
                </button>
              </>
            ) : (
              renderStatusMessage()
            )
          )}
        </div>
      </div>


    </div>
  );
}